<template>
  <div>
    <recap-reseau-format-affiche
      :produit="produit"
      :dateVisualisation="dateVisualisation"
      @updateDateVisualisation="$emit('editDateVisualisation', $event)"/>
    <section class="card mgt-20px">
      <header class="header-card">
        <p> {{ $t('catalogue.formatsAffiche.title') }} </p>
      </header>
      <div class="card-content">
        <table class="VueTables__table table is-bordered is-fullwidth">
          <thead>
            <th class="colonne-responsive width-150px">
              {{ $t('catalogue.formatsAffiche.title') }}
            </th>
            <th class="colonne-responsive">
              {{ $t('catalogue.formatsAffiche.visuel') }}
            </th>
            <th class="colonne-responsive">
              {{ $t('catalogue.formatsAffiche.impression') }}
            </th>
            <th class="colonne-responsive">
              {{ $t('catalogue.formatsAffiche.faconnage') }}
            </th>
            <th class="colonne-responsive">
              {{ $t('catalogue.formatsAffiche.expedition') }}
            </th>
          </thead>
          <tbody>
            <td v-if="!formatAffiches.length" colspan="5">
              {{ $t('general.autocomplete.noRslt') }}</td>
            <tr
              v-for="(item, index) in formatAffiches"
              :key="`formatAffiche_${index}`">
              <td>
                <p> {{ `${item.formatAffiche.code} - ${item.formatAffiche.libelle}` }} </p>
                <p> {{ dimensionToString(item.formatAffiche) }} </p>
              </td>
              <td>
                <etape-information
                  :origin-data="item.formatAffiche.visuel"
                  :data="item.visuel"
                  :detail="detail"
                />
              </td>
              <td>
                <etape-information
                  :origin-data="item.formatAffiche.impression"
                  :data="item.impression"
                  :detail="detail"
                />
              </td>
              <td>
                <etape-information
                  :origin-data="item.formatAffiche.faconnage"
                  :data="item.faconnage"
                  :detail="detail"
                />
              </td>
              <td>
                <etape-information
                  :origin-data="item.formatAffiche.expedition"
                  :data="item.expedition"
                  :detail="detail"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import EtapeInformation from '@/components/parametrage/formatAffiche/etapeInformation';
import RecapReseauFormatAffiche from '@/components/catalogue/produitGeneral/livraison/recapReseauFormatAffiche';
import moment from 'moment';
import { INFINITE_DAY } from '@/configuration/general';

export default {
  name: 'EtapeInformationEditDetail',
  components: {
    EtapeInformation,
    RecapReseauFormatAffiche,
  },
  props: {
    produit: {
      type: Object,
      required: true,
    },
    detail: {
      type: Boolean,
      default: false,
    },
    dateVisualisation: {
      type: Date,
      required: false,
    },
  },
  computed: {
    formatAffiches() {
      const affectationsFiltrees = this.produit.produitReseau.affectationsReseauFace
        .filter(aff => {
          const dateFin = aff.dateFin ? moment(aff.dateFin) : moment(INFINITE_DAY);
          return this.dateVisualisation ? moment(this.dateVisualisation).isBetween(moment(aff.dateDebut), dateFin, 'day', '[]') : true;
        });
      const formatAfficheIds = Array.from(new Set(
        affectationsFiltrees
          .reduce((acc, val) => {
            const id = val.produit.produitFace.face?.materiel?.materielTechnique?.formatAfficheId;
            if (id) acc.push(id);
            return acc;
          }, []),
      ));
      return this.produit.produitReseau.formatsAffiche
        .filter(format => formatAfficheIds.includes(format.formatAfficheId))
        .sort((a, b) => {
          return a.formatAffiche.libelle.localeCompare(b.formatAffiche.libelle);
        });
    },
  },
  methods: {
    dimensionToString(item) {
      return `${item.largeur} ${this.$t('general.mm')} x ${item.longueur} ${this.$t('general.mm')}`;
    },
  },
};
</script>
